<template>
  <el-upload
      :action="uploadUrl"
      :before-upload="beforeUpload"
      :on-success="successHandle"
      :show-file-list="false"
      :on-error="errorHandle"
      :data="params"
  >
    <el-button type="warning" size="mini" icon="el-icon-upload">
      {{ buttonText }}
    </el-button>
  </el-upload>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'UploadButton',
  props: {
    allows: {
      type: Array,
      delete: () => {
        return []
      }
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    url: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '读取EXCEL文件',
    },
    successText: {
      type: String,
      default: '读取成功',
    },
    maxSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      uploading: false
    }
  },
  computed: {
    uploadUrl () {
      return `${window.SITE_CONFIG['api2URL']}${this.url}?token=${Cookies.get('token')}`
    }
  },
  methods: {
    beforeUpload (file) {
      let ext = file.name.substring(file.name.indexOf('.'))
      let isWhite = this.$c.isArrayEmpty(this.allows) || this.allows.filter((item) => item === ext)
      const isLimit = file.size / 1024 / 1024 < this.maxSize

      if (!isWhite) {
        this.$message.error('上传文件格式错误')
      }
      if (!isLimit) {
        this.$message.error(`文件大小不能超过 ${this.uploadConfig.maxSize}MB!`)
      }
      const isContinue = isWhite && isLimit
      if (isContinue) {
        this.uploading = true
        this.loading = this.$loading()
      }
      return isContinue
    },
    successHandle (res, file, fileList) {
      this.uploading = false
      this.loading.close()
      if (res.code === 0) {
        this.$message.success(this.successText)
        this.$emit('success', res.data)
      } else {
        return this.$message.error(res.msg)
      }
    },
    errorHandle (err, file, fileList) {
      this.loading.close()
      this.uploading = false
      this.$message.error('上传失败')
    }
  }
}
</script>

<style scoped>

</style>
